import { render } from "./ProviderAndGamePage.vue?vue&type=template&id=aa4ec9ac"
import script from "./ProviderAndGamePage.vue?vue&type=script&lang=js"
export * from "./ProviderAndGamePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__